'use strict';

function ReferralShareBar() {
  this.id = null;
  this.node = null;
  this.extends = [_ResponsiveLayout, _Paths];

  this.presenter = $('[data-mogo-ui=Portal]').mogo().presenter;
  this.referralCode = this.presenter.getModelProperty('account.referral_code');
  this.shareurl = null; // Prod
  this.shareurlTest = null; // QA
  this.contentfulShareKey = null; // Required for contentful driven content
  this.referralPanelShareBar = null; // Referral Panel Tray which extends this class
  this.analyticsIdentifier = '';
  this.mobileShareBarResetSpeed = 3000;
  this._activeShareWindow = null;
  this.analytics = new Analytics();

  this._FB_APP_ID = 2086740878273293; // Admin: https://www.facebook.com/peterwilson

  this.el = {};

  this._classes = {
    shareButton: 'js--share-button',
    socialBarShowing: 'referral-share-bar--mobile-bar-showing',
    emailLink: 'js--share-email',
    facebookLink: 'js--share-facebook',
    twitterLink: 'js--share-twitter'
  };

  this.init = function () {
    this.$node = $(this.node);
    this.portal = $('[data-mogo-ui=Portal]').mogo();
    this.contentfulService = this.node.querySelector('[data-mogo-ui=ContentfulService');

    if (this.contentfulService) {
      this.csPromise = this.contentfulService.mogo().contentLoadedPromise;
    }

    if (!this.shareurl) {
      console.error('ReferralShareBar.js: "shareurl" is a required argument.');
      this.$node.hide();
      return false;
    }

    //  If shareurlTest exist, use that url for qa environment
    if (this.shareurlTest) {
      this.shareurl = window.location.host !== 'www.mogo.ca' ? this.shareurl : this.shareurl;
    }

    this.el.$shareButton = this.$node.find('.' + this._classes.shareButton);
    this.el.$emailLink = this.$node.find('.' + this._classes.emailLink);
    this.el.$facebookLink = this.$node.find('.' + this._classes.facebookLink);
    this.el.$twitterLink = this.$node.find('.' + this._classes.twitterLink);

    var requiredContentPath = this._getPageContentRefString();
    var requiredContent = this.presenter.getModelProperty(requiredContentPath);

    if (typeof requiredContent === 'undefined') {
      // Some Referral Sharebars are contentful driven and
      // are not displayed on dashboards.
      // for this reason, we need to load contetnful data, wait for csPromise to resolve,
      // (it's okay to have null promise)
      $.when(this.presenter._contentLoadedPromise, this.csPromise).then(this._onContentfulLoaded.bind(this));
    } else {
      this._onContentfulLoaded();
    }
  };

  this.initAllReady = function () {
    this.history = new History();
  };

  this._onContentfulLoaded = function () {
    // Set requiredContent when contentfulLoaded is ready
    this.requiredContentPath = this._getPageContentRefString();
    this.requiredContent = this.presenter.getModelProperty(this.requiredContentPath);

    if (!this.requiredContent) console.warn('ReferralShareBar.js: unable to retreive content model for ' + this.requiredContentPath);

    if (this.referralPanelShareBar) {
      this.$node.on('click', this._showReferralPanel.bind(this));
    } else {
      this.$node.on('click', this._displayMobileShareBar.bind(this));
    }

    if (!this.referralPanelShareBar) {
      this._setupEmailLink();
      this._setupFacebookLink();
      this._setupTwitterLink();
      this._setupShareButtons();
    }

    this.portal.scanNodeForClickAnalytics(this.node);
  };

  this._setupEmailLink = function () {
    var nodeContentRefString = this.el.$emailLink.data();
    var subject = this.presenter.getModelProperty(this.requiredContentPath + '.' + nodeContentRefString.subject);
    var body = this.presenter.getModelProperty(this.requiredContentPath + '.' + nodeContentRefString.description);

    this.el.$emailLink.attr('href', 'mailto:?subject=' + subject + '&body=' + encodeURIComponent(body) + ' ' + encodeURIComponent(this.shareurl) + encodeURIComponent('?referral_code=') + this.referralCode + '%0D%0D');
    // analytics
    this.el.$emailLink.attr('data-analytics-id', 'Referral-Share on Email' + (this.analyticsIdentifier ? '_' + this.analyticsIdentifier : '') + '-' + this.referralCode + '-null-Click');
  };

  this._setupFacebookLink = function () {
    this.el.$facebookLink.attr('href', 'https://www.facebook.com/dialog/feed?app_id=' + this._FB_APP_ID + '&link=' + this.shareurl + '?referral_code=' + this.referralCode);
    // analytics
    this.el.$facebookLink.attr('data-analytics-id', 'Referral-Share on Facebook' + (this.analyticsIdentifier ? '_' + this.analyticsIdentifier : '') + '-' + this.referralCode + '-null-Click');
  };

  this._setupTwitterLink = function () {
    var nodeContentRefString = this.el.$twitterLink.data();
    var subject = this.presenter.getModelProperty(this.requiredContentPath + '.' + nodeContentRefString.subject);
    this.el.$twitterLink.attr('href', '' + ('https://twitter.com/intent/tweet?' + '&original_referer=https://www.mogo.ca&ref_src=twsrc%5Etfw&related=MogoMoney&text=') + encodeURIComponent(subject) + '&tw_p=tweetbutton&url=' + this.shareurl + '?referral_code=' + this.referralCode);
    // analytics
    this.el.$twitterLink.attr('data-analytics-id', 'Referral-Share on Twitter' + (this.analyticsIdentifier ? '_' + this.analyticsIdentifier : '') + '-' + this.referralCode + '-null-Click');
  };

  this._setupShareButtons = function () {
    var _this = this;

    this.el.$shareButton.click(function (e) {
      e.preventDefault();
      _this.setActiveViewport();

      // used to center new window in the screen
      var topPosition = window.top.outerHeight / 2 + window.top.screenY - 446 / 2;
      var leftPosition = window.top.outerWidth / 2 + window.top.screenX - 640 / 2;

      if (_this.largeViewport || _this.xlargeViewport) {
        this._activeShareWindow = window.open($(this).attr('href'), 'shareWindow', 'width=640, height=446, top=' + topPosition + ', left=' + leftPosition);
      } else {
        // mobile needs to open a new tab every time you click:
        this._activeShareWindow = window.open($(this).attr('href'), null);
      }
    });
  };

  this._showReferralPanel = function () {
    this.analytics.forcePushEvent('generic-member-navigation', {
      memberNavigation: [this.referralPanelShareBar + '-Navigation-Referral banner-Navigation-Component']
    });
    this.history.goToUrl(this.paths.account.referral_panel);
  };

  this._displayMobileShareBar = function () {
    var _this2 = this;

    this.setActiveViewport();
    if (this.smallViewport) {
      if (!this.$node.hasClass(this._classes.socialBarShowing)) {
        this.$node.addClass(this._classes.socialBarShowing);

        this.analytics.forcePushEvent('generic-member-navigation', {
          memberNavigation: ['Invite Friends']
        });

        setTimeout(function () {
          _this2.$node.removeClass(_this2._classes.socialBarShowing);
        }, this.mobileShareBarResetSpeed);
      }
    }
  };

  /*  
    _getPageContentRefString: builds a reference string,
    this reference string is used in getModelProperty.
     The referral share bar can either be scoped to the page view or
    specific contentful content, depending on the presence of contentfulShareKey.
  */
  this._getPageContentRefString = function () {
    var ref = '';
    if (this.contentfulShareKey) {
      ref = 'content.pages.' + this.contentfulShareKey;
    } else {
      ref = 'content.pages.' + this.node.closest('[data-mogo-page]').dataset.mogoPage;
    }
    return ref;
  };

  this.destroy = function () {};
}